import { connect } from 'react-redux';

import config from '@config';
import { setUXProp, hideDetailPanel } from '@store/actions/ux';
import ViewToggle from './viewtoggle';

const mapStateToProps = state => ({
  view: state.ux.view,
});

const mapDispatchToProps = dispatch => ({
  setView: (view, target) => {
    if (view !== target) {
      dispatch(setUXProp({ view: target }));
      window.dispatchEvent(new Event(config.events.changeView));
    }
    if (target !== 'grid') {
      dispatch(hideDetailPanel());
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewToggle);
